<template>
  <div id="layout" :class="{ dark: global.darkMode }">
    <transition name="fade" v-if="!loaderFinished">
      <SiteLoader @setLoaderFinished="setLoaderFinished" />
    </transition>
    <transition-group name="fade" v-else>
      <div class="sections" key="1">
        <TopNav />
        <Landing />
        <div id="upper-layer">
          <FeaturedProject />
          <ProjectBanner />
          <ProjectCarousel />
          <!-- <Contact /> -->
          <Footer />
        </div>
      </div>
    </transition-group>
    <Modal v-if="global.modalData !== null" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TopNav from "@/components/TopNav/TopNav";
import Modal from "@/components/global/Modal";
import {
  Landing,
  FeaturedProject,
  ProjectBanner,
  ProjectCarousel,
  Contact,
  Footer,
} from "@/components/sections";
import { SiteLoader } from "@/components/global";
import { analyticsHelper } from "@/helpers";
export default {
  name: "Layout",
  components: {
    Landing,
    FeaturedProject,
    ProjectBanner,
    ProjectCarousel,
    SiteLoader,
    TopNav,
    Contact,
    Footer,
    Modal,
  },
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      firstMount: false,
      loaderFinished: false,
      analyticsHelper,
    };
  },
  mounted() {
    console.log("Hello There! Welcome to my site.");
    this.setScreenWidth(window.innerWidth);
    this.setIsMobile(window.innerWidth <= 768);
    window.addEventListener(
      "resize",
      () => {
        this.setScreenWidth(window.innerWidth);
        this.setIsMobile(window.innerWidth <= 768);
      },
      false
    );

    this.restoreFromLocalStorage();
    this.autoDark();
    this.analyticsHelper.deviceSize();
  },
  methods: {
    autoDark() {
      if (this.global.autoDarkMode) {
        this.setDarkMode(
          window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
        );
      }

      window
        .matchMedia("(prefers-color-scheme: dark)")
        .addEventListener("change", (e) => {
          if (!this.global.autoDarkMode) return;
          const isDarkMode = e.matches;
          this.setDarkMode(isDarkMode);
        });
    },
    setLoaderFinished() {
      this.loaderFinished = true;
    },
    restoreFromLocalStorage() {
      const darkMode = localStorage.getItem("gd-darkmode");
      const locale = localStorage.getItem("gd-locale");
      const autoDark = localStorage.getItem("gd-autodarkmode");
      this.setDarkMode(darkMode);
      this.setAutoDarkMode(autoDark);
      this.setLocale(locale);
    },
    ...mapActions([
      "setScreenWidth",
      "setIsMobile",
      "setDarkMode",
      "setAutoDarkMode",
      "setLocale",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.sections .fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#upper-layer {
  // margin-top: 50px;
  padding-top: 60vh;
  position: relative;
  z-index: 3;
}
</style>
<style>
* {
  touch-action: manipulation !important;
}
</style>

<style lang="scss">
#layout {
  background-color: $lt-bg-color;
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);
}
.dark {
  background-color: $dt-bg-color;
}
</style>